<template>
  <div v-if="loginContent">
    <auth-header
      :title="loginContent?.login.title"
      :text="loginContent?.login.subtitle"
    ></auth-header>

    <div class="tab-form shadow mt-5" style="border-radius: 25px !important">
      <div v-if="signInSuccess == false" class="well well-failed">
        <div>
          <h3>{{ content.failed }}</h3>
          <p>
           Verification failed. check your code again.
          </p>
        </div>
      </div>
      <form class="row" @submit.prevent="submitForm">
        <div class="col-md-12">
          <div class="input-group mb-3">
            <label class="small d-block">Verification Code</label>
            <div class="clearfix"></div>
            <input
              type="number"
              class="form-control d-block"
              
              v-model="email"
            />
            <div class="clearfix m-0"></div>
            <p v-if="emailError" class="error-text">{{ emailError }}</p>
          </div>
        </div>

      

        <div class="mt-4 d-block d-md-flex term">
       
          <div>
            <button class="btn termbtn backbtn" @click="back">
              {{ content.back }}
            </button>
            &nbsp; &nbsp;
            <button class="form-green-btn" style="overflow: hidden">
              <Spinner v-if="submitted" />
              <span v-else>
               VERIFY
              </span>
            </button>
          </div>
        </div>

      
      </form>
    </div>
  </div>

  <Loader v-else />
</template>


<script>
import AuthHeader from "../../components/layout/AuthHeader";
import Loader from "../../components/ui/Loading.vue";
import Spinner from "../../components/ui/Spinner.vue";

export default {
  data() {
    return {
      loginContent: null,
      email: null,
      submitted: false,
      response: null,
      signInSuccess: null,
      emailError: null,
      passwordError: null,
    };
  },
  components: {
    AuthHeader,
    Loader,
    Spinner,
  },
  methods: {
    validateRequired(inputed) {
      if (inputed === "" || inputed == null) {
        return this.content.required;
      } else {
        return null;
      }
    },
   
    back() {
      this.$router.back();
    },
    async loadData() {
      await this.$store.dispatch("getAccountData");
      this.loginContent = await this.$store.getters.accountContent;
    },
    async submitForm() {
      this.submitted = true;
      this.emailError = this.validateRequired(this.email);

      if (!this.emailError ) {
       
        this.response = await this.$store.dispatch("verify", {
       
          code: this.email,
        });

        if (this.response.user && this.response.token) {
          this.submitted = false;
          this.signInSuccess = true;
          this.$store.dispatch("setAuth", {
            token: this.response.token,
            user: this.response.user,
          });

           this.$router.replace("/");


        } else if (this.response.status == "failed") {
          window.scrollTo(0, 0);
          this.signInSuccess = false;
          this.submitted = false;
        }
       
      } else {
        this.submitted = false;
      }
    },
  },
  computed: {
    content() {
      this.loadData();
      return this.$store.getters.content;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
.term {
  height: 40px;
}
@media (max-width: 992px) {
  .term {
    height: 100px;
  }
}
</style>